"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Grid = require("../../components/Grid/Grid.styles");
var _PropertyCardBody = require("../../components/PropertyCardBody/PropertyCardBody.styles");
var _PropertyCardDataArea = require("../../components/PropertyCardDataArea/PropertyCardDataArea.styles");
var _PropertyCardDataWrapper = require("../../components/PropertyCardDataWrapper/PropertyCardDataWrapper.styles");
var _PropertyCardMLSFooter = require("../../components/PropertyCardMLSFooter/PropertyCardMLSFooter.styles");
var _PropertyCardPhotoBody = require("../../components/PropertyCardPhotoBody/PropertyCardPhotoBody.styles");
var _Text = require("../../components/Text/Text.styles");
var _constants = require("../../constants");
var _spaceMixin = require("../spaceMixin");
var _spacingMixin = require("../spacingMixin");
var _typographyMixin = require("../typographyMixin");
var loadingCSS = function loadingCSS(props) {
  var loading = props.loading;
  if (!loading) {
    return '';
  }
  return (0, _styledToken.default)({
    backgroundColor: "PropertyCard.loading.backgroundColor",
    backgroundImage: "PropertyCard.loading.backgroundImage",
    dataAreaMarginBottom: 'PropertyCard.data.marginBottom',
    dataLineHeight: 'PropertyCard.data.lineHeight',
    maxCardWidth: "PropertyCard.maxWidth." + _constants.PROPERTY_CARD_APPEARANCES.LARGE,
    photoAnimationDuration: 'PropertyCard.photo.animation.duration',
    photoAnimationIterations: 'PropertyCard.photo.animation.iterations',
    dataChildrenWidth: ['PropertyCard.data.childrenWidth']
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      backgroundImage = _ref.backgroundImage,
      dataAreaMarginBottom = _ref.dataAreaMarginBottom,
      dataLineHeight = _ref.dataLineHeight,
      maxCardWidth = _ref.maxCardWidth,
      _ref$photoAnimationDu = _ref.photoAnimationDuration,
      photoAnimationDuration = _ref$photoAnimationDu === void 0 ? 1.5 : _ref$photoAnimationDu,
      _ref$photoAnimationIt = _ref.photoAnimationIterations,
      photoAnimationIterations = _ref$photoAnimationIt === void 0 ? 'infinite' : _ref$photoAnimationIt,
      _ref$dataChildrenWidt = _ref.dataChildrenWidth,
      dataChildrenWidth = _ref$dataChildrenWidt === void 0 ? {
        one: '6em',
        two: '95%',
        three: '85%'
      } : _ref$dataChildrenWidt;
    var shimmer = /*#__PURE__*/(0, _styledComponents.keyframes)(["0%{background-position-x:-", "px;}100%{background-position-x:", "px;}"], maxCardWidth, maxCardWidth);
    return (0, _styledComponents.css)(["", ",", "{background-color:", ";background-size:", "px;background-repeat:no-repeat;background-image:", ";animation-name:", ";animation-duration:", "s;animation-iteration-count:", ";}@media (prefers-reduced-motion:reduce){", ",", "{animation:none;}}", "{line-height:", ";margin-bottom:", ";&:nth-child(1){width:", ";}&:nth-child(2){width:", ";}&:nth-child(3){width:", ";}&:last-child{margin-bottom:0;}}"], _PropertyCardDataArea.StyledPropertyCardDataArea, _PropertyCardPhotoBody.StyledPropertyCardPhotoBody, backgroundColor, maxCardWidth, backgroundImage, shimmer, photoAnimationDuration, photoAnimationIterations, _PropertyCardDataArea.StyledPropertyCardDataArea, _PropertyCardPhotoBody.StyledPropertyCardPhotoBody, _PropertyCardDataArea.StyledPropertyCardDataArea, dataLineHeight, dataAreaMarginBottom ? dataAreaMarginBottom + "px" : (0, _spaceMixin.spaceMixin)('xs')(props), dataChildrenWidth.one, dataChildrenWidth.two, dataChildrenWidth.three);
  });
};
var flagCSS = function flagCSS(props) {
  /* Gives Flag Card a slightly darker shadow because it usually appears over a map */
  var appearance = props.appearance,
    cardElevation = props.cardElevation,
    interactive = props.interactive;
  if (appearance !== _constants.PROPERTY_CARD_APPEARANCES.FLAG) {
    return '';
  }
  return (0, _styledToken.default)({
    cardBodyBoxShadow: "PropertyCard.cardBody.boxShadow." + _constants.PROPERTY_CARD_APPEARANCES.FLAG,
    cardBodyBoxShadowHover: "PropertyCard.cardBody.boxShadow.hover." + _constants.PROPERTY_CARD_APPEARANCES.FLAG,
    focusShadow: 'PropertyCard.cardBody.boxShadow.focus',
    width: "PropertyCard.width." + _constants.PROPERTY_CARD_APPEARANCES.FLAG
  }, function (_ref2) {
    var cardBodyBoxShadow = _ref2.cardBodyBoxShadow,
      cardBodyBoxShadowHover = _ref2.cardBodyBoxShadowHover,
      focusShadow = _ref2.focusShadow,
      width = _ref2.width;
    return (0, _styledComponents.css)(["width:", "px;", "{box-shadow:", ";", "}"], width, _PropertyCardBody.StyledPropertyCardBody, cardElevation === 1 ? cardBodyBoxShadow : 'none', interactive && cardElevation === 1 && (0, _styledComponents.css)(["&:hover{box-shadow:", ";}&:focus{box-shadow:", ";}&:focus:hover{box-shadow:", ";}&:active{box-shadow:", ";}"], cardBodyBoxShadowHover, cardBodyBoxShadow + ", " + focusShadow, cardBodyBoxShadowHover + ", " + focusShadow, focusShadow));
  })(props);
};

/** @class PropertyCardMixin */
/** @method */
var PropertyCardMixin = function PropertyCardMixin(props) {
  var appearance = props.appearance,
    cardGridTemplate = props.cardGridTemplate;
  var isVerticalCard = appearance === _constants.PROPERTY_CARD_APPEARANCES.LARGE || appearance === _constants.PROPERTY_CARD_APPEARANCES.SMALL;
  return (0, _styledToken.default)({
    cardBodyPadding: 'PropertyCard.cardBody.padding',
    dataAreaMarginTop: 'PropertyCard.data.marginTop',
    defaultGridTemplate: "PropertyCard.cardBody.gridTemplate." + appearance,
    gridTemplateAreas: "PropertyCard.gridTemplateAreas." + appearance,
    hoverBackgroundColor: 'PropertyCard.cardBody.backgroundColor.hover',
    maxWidth: "PropertyCard.maxWidth." + appearance,
    minWidth: "PropertyCard.minWidth." + appearance,
    mlsTextAlign: ['PropertyCard.mls.text.align'],
    mlsFontType: "PropertyCard.mls.fontType." + appearance,
    mlsFontWeight: 'PropertyCard.mls.fontWeight',
    wrapperPadding: ['PropertyCard.wrapper.padding']
  }, function (_ref3) {
    var _ref3$cardBodyPadding = _ref3.cardBodyPadding,
      cardBodyPadding = _ref3$cardBodyPadding === void 0 ? 0 : _ref3$cardBodyPadding,
      dataAreaMarginTop = _ref3.dataAreaMarginTop,
      defaultGridTemplate = _ref3.defaultGridTemplate,
      gridTemplateAreas = _ref3.gridTemplateAreas,
      _ref3$hoverBackground = _ref3.hoverBackgroundColor,
      hoverBackgroundColor = _ref3$hoverBackground === void 0 ? '#fff' : _ref3$hoverBackground,
      maxWidth = _ref3.maxWidth,
      minWidth = _ref3.minWidth,
      mlsFontType = _ref3.mlsFontType,
      mlsFontWeight = _ref3.mlsFontWeight,
      mlsTextAlign = _ref3.mlsTextAlign,
      wrapperPadding = _ref3.wrapperPadding;
    return (0, _styledComponents.css)(["height:", ";max-width:", "px;min-width:", "px;", "{display:grid;grid-template-areas:", ";grid-template-", ":", ";height:", ";padding:", ";-webkit-tap-highlight-color:transparent;&:hover,&:active{background-color:", ";}& + ", "{&:empty{display:none;}& > ", "{margin-top:", ";}}}", "{padding:", ";}", "{justify-content:", ";", "{", " font-weight:", ";text-align:", ";}}", " ", " ", ""], appearance === _constants.PROPERTY_CARD_APPEARANCES.LARGE ? '100%' : 'fit-content', maxWidth, minWidth, _PropertyCardBody.StyledPropertyCardBody, gridTemplateAreas, isVerticalCard ? 'rows' : 'columns', cardGridTemplate || defaultGridTemplate, appearance === _constants.PROPERTY_CARD_APPEARANCES.LARGE ? '100%' : 'auto', cardBodyPadding, hoverBackgroundColor, _Grid.StyledGrid, _PropertyCardDataArea.StyledPropertyCardDataArea, dataAreaMarginTop ? dataAreaMarginTop + "px" : (0, _spaceMixin.spaceMixin)('xs')(props), _PropertyCardDataWrapper.StyledPropertyCardDataWrapper,
    // eslint-disable-next-line no-nested-ternary
    appearance === _constants.PROPERTY_CARD_APPEARANCES.FLAG ? wrapperPadding ? wrapperPadding[_constants.PROPERTY_CARD_APPEARANCES.FLAG].Y + "px " + wrapperPadding[_constants.PROPERTY_CARD_APPEARANCES.FLAG].X + "px" : (0, _spaceMixin.spaceMixin)(0.5)(props) + " " + (0, _spaceMixin.spaceMixin)('xs')(props) : wrapperPadding ? "" + wrapperPadding.default : "" + (0, _spaceMixin.spaceMixin)('xs')(props), _PropertyCardMLSFooter.StyledPropertyCardMLSFooter, appearance === _constants.PROPERTY_CARD_APPEARANCES.LARGE ? 'end' : 'space-between', _Text.StyledText, (0, _typographyMixin.typographyMixin)(Object.assign({
      fontColor: 'inherit',
      fontType: mlsFontType
    }, props)), mlsFontWeight, appearance === _constants.PROPERTY_CARD_APPEARANCES.LARGE ? mlsTextAlign[_constants.PROPERTY_CARD_APPEARANCES.LARGE] : mlsTextAlign.default, flagCSS(props), (0, _spacingMixin.spacingMixin)(props), loadingCSS(props));
  });
};
exports.PropertyCardMixin = PropertyCardMixin;